<template>
  <div class="layout">
    <el-container>
      <ots-head/>
    </el-container>
    <el-container class='main mainH' :class="isUseNewBG == 'index' ? 'main_index': ''">
      <ots-sider />
      <el-main>
        <div class="mian-box">
          <router-view class="mian-con">
          </router-view>
          <el-footer v-if="isShowFooter" class="footerWidth" :class="{footerW:hasScroll}">
            <div class="myFooter">
              <el-button plain round @click="goBack()">{{cancelName}}</el-button>
              <el-button type="primary" round @click="save()">{{okName}}</el-button>
            </div>
          </el-footer>
          <copyright />
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import OtsHead from '@/components/out-header.vue'
  import OtsSider from '@/components/out-sider.vue'
  import copyright from '@/components/copyright.vue'
  export default {
    name: 'layout',
    components: {
      OtsHead,
      OtsSider,
      copyright
    },
    data() {
      return {
        hasScroll: false,
        cancelName: '取消',
        okName: '确定',
        bgImg: require('@/assets/img/newIndexBG.jpg'),
      }
    },
    computed: {
      ...mapState(['pageThis']),
      isShowFooter() {
        return this.showFooterPage.indexOf(this.$route.name) !== -1
      },

      isUseNewBG() {
        return this.$route.name;
      },

    },
    watch: {
      $route: 'getHasScroll'
    },
    updated() {
      this.setBtnName()
    },
    mounted() {
      this.getHasScroll();
    },
    methods: {
      ...mapMutations(['SAVE_PAGE_THIS']),
      goBack() {
        let {pageThis} = this
        if (pageThis.backMethods) {
          pageThis[pageThis.backMethods]()
        } else {
          pageThis && pageThis.goBack()
        }
      },
      save() {
        let {pageThis} = this
        if (pageThis.saveMethods) { 
          pageThis[pageThis.saveMethods]()
        } else {
          pageThis && pageThis.save()
        }
      },
      getHasScroll(val) {
        if (!this.isShowFooter) return
        this.$nextTick(() => {
          let sH = document.querySelector('.mian-con').scrollHeight
          let cH = document.querySelector('.mian-con').clientHeight
          this.hasScroll = sH > cH
        })
        this.setBtnName()
      },
      setBtnName() {
        if (!this.isShowFooter) return
        let {pageThis} = this
        if (pageThis) {
          this.cancelName = pageThis.cancelName || "取消"
          this.okName = pageThis.okName || "确定"
        }
      }
    },
  }
</script>

<style scoped lang='less'>
  .main {
    height: calc(100% - 60px);
    padding: 24px 0;
    background: #F5F7FA;
  }
  .main_index {
    background: url("../assets/img/newIndexBG.jpg");
  }
  .layout {
    height: 100%;
    min-width: 1280px;
  }

  .mian-box {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .el-main {
    padding: 0;
  }

  .mian-con {
    box-sizing: border-box;
    padding: 0 24px;
    // padding-left: 16px;
    flex: 1 1;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .mian-con.full-screen {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
  }

  .el-footer {
    border-radius:0 0 8px 8px;
    box-sizing: border-box;
    width: calc(100% - 48px);
    height: 72px !important;
    /* 修改为 24px */
    margin-left: 24px;
    box-shadow: 0px -8px 16px 0px rgba(0, 0, 0, 0.06);
    z-index: 5;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;

  }

  .footerW {
    /* 重新计算数值 */
    width: calc(100% - 53px);
  }
</style>
